export const getUniqArray = (arr) => {
  const unicSet = new Set(arr);
  return [...unicSet];
};
